/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Export_All_ButtonInputs */

const en_preset_manager_export_all_button = /** @type {(inputs: Preset_Manager_Export_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export All`)
};

const fr_preset_manager_export_all_button = /** @type {(inputs: Preset_Manager_Export_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout exporter`)
};

const de_preset_manager_export_all_button = /** @type {(inputs: Preset_Manager_Export_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle exportieren`)
};

const it_preset_manager_export_all_button = /** @type {(inputs: Preset_Manager_Export_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta tutto`)
};

const ru_preset_manager_export_all_button = /** @type {(inputs: Preset_Manager_Export_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт всех`)
};

const es_preset_manager_export_all_button = /** @type {(inputs: Preset_Manager_Export_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar todo`)
};

const zh_cn2_preset_manager_export_all_button = /** @type {(inputs: Preset_Manager_Export_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部导出`)
};

const ja_preset_manager_export_all_button = /** @type {(inputs: Preset_Manager_Export_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてエクスポート`)
};

const hi_preset_manager_export_all_button = /** @type {(inputs: Preset_Manager_Export_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी निर्यात करें`)
};

const pt_pt2_preset_manager_export_all_button = /** @type {(inputs: Preset_Manager_Export_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar tudo`)
};

/**
* | output |
* | --- |
* | "Export All" |
*
* @param {Preset_Manager_Export_All_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_export_all_button = /** @type {((inputs?: Preset_Manager_Export_All_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Export_All_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_export_all_button(inputs)
	if (locale === "de") return de_preset_manager_export_all_button(inputs)
	if (locale === "it") return it_preset_manager_export_all_button(inputs)
	if (locale === "ru") return ru_preset_manager_export_all_button(inputs)
	if (locale === "es") return es_preset_manager_export_all_button(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_export_all_button(inputs)
	if (locale === "ja") return ja_preset_manager_export_all_button(inputs)
	if (locale === "hi") return hi_preset_manager_export_all_button(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_export_all_button(inputs)
	return en_preset_manager_export_all_button(inputs)
});